import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import InternetForm from './InternetForm'

const formName = 'internet'
const stateToProps = ({ form }) => ({
  formData: get(form, `${formName}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    form: formName,
  })(InternetForm)
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Internet/InternetForm/InternetForm.container.js